// Landing page for API customers
import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import logo from '../../sidebar-logo.png';
import mixpanel from 'mixpanel-browser';
import {
  Code as CodeIcon,
  RssFeed as RssFeedIcon,
  Link as LinkIcon,
  Description as TextIcon,
  CloudUpload as UploadIcon,
  Podcasts as PodcastIcon,
  ArrowForward as ArrowIcon,
  CheckCircle as CheckIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { observer } from 'mobx-react';
import { setLandingPage } from '../../utils/trackingParams';
import OneGiftLogo from '../../Components/OneGiftLogo';

import './landingA.scss';  // Reuse the same styles

const LandingAPI = observer(() => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  
  useEffect(() => {
    mixpanel.track('API Landing Page Visited', {
      page: 'landing_api'
    });
    setLandingPage('landing_api');
  }, []);

  const renderContactButton = () => {
    return (
      <div className="cta-div" style={{ position: 'static', width: 'auto' }}>
        <a
          href="mailto:dev@audioread.com"
          className="cta-button"
          onClick={() => {
            mixpanel.track('Click Contact API', {
              placement: 'api_landing'
            });
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div>Request API Access</div>
          </div>
        </a>
      </div>
    );
  };

  const APIFeatureCard = ({ icon, title, description }) => (
    <div style={{
      background: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '12px',
      padding: '24px',
      width: '280px',
      margin: '12px',
      transition: 'transform 0.2s ease',
      cursor: 'pointer',
    }} className="use-case-card">
      {icon}
      <h3 style={{ marginTop: '16px', fontSize: '1.2em' }}>{title}</h3>
      <p style={{ fontSize: '0.9em', opacity: 0.8 }}>{description}</p>
    </div>
  );

  const APIFlowDiagram = () => (
    <div style={{
      maxWidth: '1000px',
      margin: '60px auto',
      padding: '40px 20px',
      background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.05) 0%, rgba(133, 53, 205, 0.05) 100%)',
      borderRadius: '24px',
      border: '1px solid rgba(255, 255, 255, 0.1)'
    }}>
      <h3 style={{
        textAlign: 'center',
        marginBottom: '40px',
        fontSize: '1.8em',
        background: 'linear-gradient(135deg, #4292fa 0%, #8535cd 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}>
        How It Works
      </h3>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px'
      }}>
        {/* Input Sources Row */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #4292fa 0%, #8535cd 100%)',
            padding: '16px 24px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 8px 32px rgba(66, 146, 250, 0.3)'
          }}>
            <LinkIcon style={{ color: 'white', fontSize: '24px' }} />
            <span style={{ color: 'white', fontWeight: '600' }}>Article URL</span>
          </div>
          
          <div style={{
            background: 'linear-gradient(135deg, #8535cd 0%, #e82186 100%)',
            padding: '16px 24px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 8px 32px rgba(133, 53, 205, 0.3)'
          }}>
            <TextIcon style={{ color: 'white', fontSize: '24px' }} />
            <span style={{ color: 'white', fontWeight: '600' }}>Raw Text</span>
          </div>
          
          <div style={{
            background: 'linear-gradient(135deg, #e82186 0%, #ff5c57 100%)',
            padding: '16px 24px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 8px 32px rgba(232, 33, 134, 0.3)'
          }}>
            <UploadIcon style={{ color: 'white', fontSize: '24px' }} />
            <span style={{ color: 'white', fontWeight: '600' }}>File Upload</span>
          </div>
          
          <div style={{
            background: 'linear-gradient(135deg, #ff5c57 0%, #00bcd4 100%)',
            padding: '16px 24px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 8px 32px rgba(255, 92, 87, 0.3)'
          }}>
            <RssFeedIcon style={{ color: 'white', fontSize: '24px' }} />
            <span style={{ color: 'white', fontWeight: '600' }}>RSS Feed</span>
          </div>
        </div>

        {/* Arrow */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#4292fa',
          fontSize: '1.2em',
          fontWeight: '600'
        }}>
          <span>+</span>
          <div style={{
            background: 'linear-gradient(135deg, #00bcd4 0%, #4caf50 100%)',
            padding: '12px 20px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 20px rgba(0, 188, 212, 0.3)'
          }}>
            <PodcastIcon style={{ color: 'white', fontSize: '20px' }} />
            <span style={{ color: 'white', fontWeight: '600', fontSize: '0.9em' }}>Podcast Feed Link (Optional)</span>
          </div>
        </div>

        {/* Arrow Down */}
        <ArrowIcon style={{ 
          fontSize: '40px', 
          color: '#4292fa',
          transform: 'rotate(90deg)',
          margin: '10px 0'
        }} />

        {/* Audioread Processing */}
        <div style={{
          background: 'linear-gradient(135deg, #4292fa 0%, #8535cd 100%)',
          padding: '32px',
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          boxShadow: '0 16px 48px rgba(66, 146, 250, 0.4)',
          border: '2px solid rgba(255, 255, 255, 0.2)'
        }}>
          <img 
            src={process.env.PUBLIC_URL + '/logo64.png'} 
            alt="Audioread" 
            style={{ 
              width: '60px', 
              height: '60px'
            }} 
          />
          <div>
            <h4 style={{ color: 'white', margin: '0 0 8px 0', fontSize: '1.4em' }}>
              Audioread API
            </h4>
            <p style={{ color: 'white', margin: 0, opacity: 0.9, fontSize: '1.1em' }}>
              Converts text to human-sounding speech
            </p>
          </div>
        </div>

        {/* Arrow Down */}
        <ArrowIcon style={{ 
          fontSize: '40px', 
          color: '#4292fa',
          transform: 'rotate(90deg)',
          margin: '10px 0'
        }} />

        {/* Output Options */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '30px',
          flexWrap: 'wrap'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #4caf50 0%, #00bcd4 100%)',
            padding: '24px',
            borderRadius: '16px',
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <CheckIcon style={{ color: 'white', fontSize: '32px', marginBottom: '12px' }} />
            <h4 style={{ color: 'white', margin: '0 0 8px 0' }}>Audio File</h4>
            <p style={{ color: 'white', margin: 0, opacity: 0.9, fontSize: '0.9em' }}>
              High-quality MP3 download
            </p>
          </div>
          
          <div style={{
            background: 'linear-gradient(135deg, #00bcd4 0%, #4292fa 100%)',
            padding: '24px',
            borderRadius: '16px',
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(0, 188, 212, 0.3)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <PodcastIcon style={{ color: 'white', fontSize: '32px', marginBottom: '12px' }} />
            <h4 style={{ color: 'white', margin: '0 0 8px 0' }}>Podcast Feed Link</h4>
            <p style={{ color: 'white', margin: 0, opacity: 0.9, fontSize: '0.9em' }}>
              RSS feed for any podcast app
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="App">
      <header className="App-header" style={{ minHeight: '100vh' }}>
        <div className="nav-bar">
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img className="audiblogs-logo" src={logo} alt="logo" />
            </Link>
          </div>
          
          <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{display: 'flex', alignItems: 'center', gap: '10px', transform: 'scale(0.75)', marginLeft: '-20px'}}>
              {renderContactButton()}
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px',
                  marginLeft: '5px',
                  width: '44px',
                  height: '44px',
                  minWidth: '44px',
                  minHeight: '44px',
                  flexShrink: 0
                }}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <CloseIcon style={{ fontSize: '28px' }} /> : <MenuIcon style={{ fontSize: '28px' }} />}
              </button>
            </div>
          </div>
          
          <div className="mobile-nav">
            <div style={{display: 'flex', alignItems: 'center', gap: '10px', transform: 'scale(0.75)', paddingBottom: '15px', marginRight: '-10px'}}>
              {renderContactButton()}
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px',
                  marginLeft: '5px',
                  width: '44px',
                  height: '44px',
                  minWidth: '44px',
                  minHeight: '44px',
                  flexShrink: 0
                }}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <CloseIcon style={{ fontSize: '28px' }} /> : <MenuIcon style={{ fontSize: '28px' }} />}
              </button>
            </div>
          </div>
        </div>
        
        {/* Navigation Menu (shared for desktop and mobile) - Outside nav-bar to prevent clipping */}
        {isMenuOpen && (
          <div 
            style={{
              position: 'fixed',
              top: '80px',
              right: '20px',
              backgroundColor: 'rgba(9, 2, 19, 0.95)',
              padding: '20px',
              width: '220px',
              borderRadius: '10px',
              backdropFilter: 'blur(10px)',
              zIndex: 10000,
              boxSizing: 'border-box',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              overflow: 'visible'
            }}
          >
            <div style={{display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link
                to="/features"
                className="mobile-menu-link"
                onClick={() => {
                  mixpanel.track('Click Features from Menu');
                  setIsMenuOpen(false);
                }}
                style={{ color: '#fff', textDecoration: 'none', fontSize: '16px', padding: '8px 0' }}
              >
                Features
              </Link>
              <Link
                to="/how-it-works"
                className="mobile-menu-link"
                onClick={() => {
                  mixpanel.track('Click How It Works from Menu');
                  setIsMenuOpen(false);
                }}
                style={{ color: '#fff', textDecoration: 'none', fontSize: '16px', padding: '8px 0' }}
              >
                How It Works
              </Link>
              <Link
                to="/integrations-and-platforms"
                className="mobile-menu-link"
                onClick={() => {
                  mixpanel.track('Click Integrations from Menu');
                  setIsMenuOpen(false);
                }}
                style={{ color: '#fff', textDecoration: 'none', fontSize: '16px', padding: '8px 0' }}
              >
                Integrations
              </Link>
              <Link
                to="/solutions-and-accessibility"
                className="mobile-menu-link"
                onClick={() => {
                  mixpanel.track('Click Solutions from Menu');
                  setIsMenuOpen(false);
                }}
                style={{ color: '#fff', textDecoration: 'none', fontSize: '16px', padding: '8px 0' }}
              >
                Solutions
              </Link>
              <Link
                to="/organizations"
                className="mobile-menu-link"
                onClick={() => {
                  mixpanel.track('Click Organizations from Menu');
                  setIsMenuOpen(false);
                }}
                style={{ color: '#fff', textDecoration: 'none', fontSize: '16px', padding: '8px 0' }}
              >
                Organizations
              </Link>
              <Link
                to="/api"
                className="mobile-menu-link"
                onClick={() => {
                  mixpanel.track('Click API from Menu');
                  setIsMenuOpen(false);
                }}
                style={{ color: '#fff', textDecoration: 'none', fontSize: '16px', padding: '8px 0' }}
              >
                API
              </Link>
            </div>
          </div>
        )}

        <h1 className="bigger-headline" style={{ marginTop: '40px' }}>
          Audioread API
        </h1>

        <h2 className="subheadline">
          Convert any text to natural-sounding audio with our simple API.
          <br />
          Pay per character, scale as you grow.
        </h2>

        {renderContactButton()}

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          maxWidth: '1200px',
          margin: '48px auto'
        }}>
          <APIFeatureCard
            icon={<TextIcon style={{ fontSize: '48px', color: '#4292fa' }} />}
            title="Text to Speech"
            description="Send raw text or HTML and receive high-quality audio in return. Support for multiple languages and voices."
          />
          <APIFeatureCard
            icon={<LinkIcon style={{ fontSize: '48px', color: '#8535cd' }} />}
            title="URL Processing"
            description="Send article URLs and we'll extract the content and convert it to audio automatically."
          />
          <APIFeatureCard
            icon={<UploadIcon style={{ fontSize: '48px', color: '#e82186' }} />}
            title="File Conversion"
            description="Upload PDFs, Word documents, and other file formats for automatic conversion to audio."
          />
          <APIFeatureCard
            icon={<RssFeedIcon style={{ fontSize: '48px', color: '#ff5c57' }} />}
            title="RSS Feed Support"
            description="Convert entire RSS feeds into audio podcasts. Perfect for blogs and news sites."
          />
          <APIFeatureCard
            icon={<PodcastIcon style={{ fontSize: '48px', color: '#00bcd4' }} />}
            title="Podcast Generation"
            description="Get a private podcast feed for your content that users can subscribe to in any podcast app."
          />
          <APIFeatureCard
            icon={<CodeIcon style={{ fontSize: '48px', color: '#4caf50' }} />}
            title="Simple Integration"
            description="RESTful API with comprehensive documentation and example code in multiple languages."
          />
        </div>

        <APIFlowDiagram />

        <div style={{ maxWidth: '1000px', margin: '48px auto', padding: '0 24px' }}>
          <h2 style={{ 
            textAlign: 'center', 
            marginBottom: '40px',
            background: 'linear-gradient(135deg, #4292fa 0%, #8535cd 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: '2.5em'
          }}>API Features</h2>
          <div className="feature-cards-grid">
            <div className="feature-card" style={{
              background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1) 0%, rgba(133, 53, 205, 0.1) 100%)',
              borderRadius: '16px',
              padding: '24px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }}>
              <h3 style={{ color: '#4292fa', marginBottom: '16px' }}>Content Processing</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '12px' }}>✨ Raw text conversion</li>
                <li style={{ marginBottom: '12px' }}>✨ HTML content extraction</li>
                <li style={{ marginBottom: '12px' }}>✨ Multiple file formats</li>
              </ul>
            </div>
            
            <div className="feature-card" style={{
              background: 'linear-gradient(135deg, rgba(133, 53, 205, 0.1) 0%, rgba(232, 33, 134, 0.1) 100%)',
              borderRadius: '16px',
              padding: '24px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }}>
              <h3 style={{ color: '#8535cd', marginBottom: '16px' }}>Voice Options</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '12px' }}>✨ Multiple voice choices</li>
                <li style={{ marginBottom: '12px' }}>✨ Language support</li>
                <li style={{ marginBottom: '12px' }}>✨ Speech customization</li>
              </ul>
            </div>

            <div className="feature-card" style={{
              background: 'linear-gradient(135deg, rgba(232, 33, 134, 0.1) 0%, rgba(255, 92, 87, 0.1) 100%)',
              borderRadius: '16px',
              padding: '24px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }}>
              <h3 style={{ color: '#e82186', marginBottom: '16px' }}>Podcast Features</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '12px' }}>✨ Private RSS feeds</li>
                <li style={{ marginBottom: '12px' }}>✨ Feed management</li>
                <li style={{ marginBottom: '12px' }}>✨ Episode metadata</li>
              </ul>
            </div>

            <div className="feature-card" style={{
              background: 'linear-gradient(135deg, rgba(255, 92, 87, 0.1) 0%, rgba(66, 146, 250, 0.1) 100%)',
              borderRadius: '16px',
              padding: '24px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
            }}>
              <h3 style={{ color: '#ff5c57', marginBottom: '16px' }}>Developer Tools</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '12px' }}>✨ RESTful endpoints</li>
                <li style={{ marginBottom: '12px' }}>✨ Webhook support</li>
                <li style={{ marginBottom: '12px' }}>✨ Detailed analytics</li>
              </ul>
            </div>
          </div>
        </div>

        <div style={{ 
          marginTop: '80px',
          marginBottom: '80px',
          background: 'linear-gradient(135deg, rgba(66, 146, 250, 0.1) 0%, rgba(133, 53, 205, 0.1) 100%)',
          padding: '60px 20px',
          borderRadius: '24px',
          maxWidth: '1000px',
          margin: '80px auto'
        }}>
          <h2 style={{
            fontSize: '2.5em',
            marginBottom: '24px',
            background: 'linear-gradient(135deg, #4292fa 0%, #8535cd 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>Ready to get started?</h2>
          <p style={{ fontSize: '1.3em', margin: '24px 0', opacity: 0.9 }}>
            Contact our developer team to request an API key and start converting content today.
          </p>
          {renderContactButton()}
        </div>
      </header>

      <OneGiftLogo />
      <div className="footer-links" style={{ margin: '25px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/dmca">DMCA Policy</Link>
      </div>
      <div style={{ margin: '25px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
        <a href="mailto:dev@audioread.com" target="_blank" rel="noopener noreferrer">
          Contact us at dev@audioread.com
        </a>
      </div>
      <div style={{ margin: '25px', opacity: 0.7 }}>© {new Date().getFullYear()} Audioread™. All rights reserved.</div>
    </div>
  );
});

export default LandingAPI;
